import React from "react";
import AntdPopconfirm from "antd/lib/popconfirm";
import { withError} from '@fishx/tracker';

const Popconfirm = (props) => <AntdPopconfirm {...props}/>
Popconfirm.displayName = 'Popconfirm';
export default withError(Popconfirm);



// WEBPACK FOOTER //
// ./src/components/popconfirm/index.tsx